export interface DiceRoll {
  count: number;
  sides: number;
  modifier: number;
  raw: string;
}

export function parseDice(diceStr: string): DiceRoll {
  // Parse formats like "3d6+3", "2d6", "1d4+1", "5"
  const match = diceStr.match(/^(\d+)d(\d+)([+-]\d+)?$/);
  if (match) {
    return {
      count: parseInt(match[1], 10),
      sides: parseInt(match[2], 10),
      modifier: match[3] ? parseInt(match[3], 10) : 0,
      raw: diceStr,
    };
  }

  // Plain number (like "5" for heal spells)
  const num = parseInt(diceStr, 10);
  if (!isNaN(num)) {
    return {
      count: 0,
      sides: 0,
      modifier: num,
      raw: diceStr,
    };
  }

  // Empty string
  return {
    count: 0,
    sides: 0,
    modifier: 0,
    raw: diceStr,
  };
}

export function rollDice(dice: DiceRoll): number {
  let total = dice.modifier;
  for (let i = 0; i < dice.count; i++) {
    total += Math.floor(Math.random() * dice.sides) + 1;
  }
  return total;
}

export function rollDiceStr(diceStr: string): number {
  return rollDice(parseDice(diceStr));
}

export function diceMin(dice: DiceRoll): number {
  return dice.count + dice.modifier;
}

export function diceMax(dice: DiceRoll): number {
  return dice.count * dice.sides + dice.modifier;
}

export function diceAvg(dice: DiceRoll): number {
  return dice.count * ((dice.sides + 1) / 2) + dice.modifier;
}

export function random(max: number): number {
  return Math.floor(Math.random() * max);
}

export function randomRange(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
